module.exports = __webpack_public_path__ + "static/media/23.b8ba835d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/23.jpg
// module id = 198
// module chunks = 0